import firebase from '../firebase'

export function login (username, password) {
  return firebase.auth().signInWithEmailAndPassword(username, password)
}

export function getUserInfo (idUser) {
  return firebase.firestore()
    .collection('usuarios')
    .doc(idUser)
    .get()
}

export function isUserLogged () {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        resolve(true)
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(false)
      }
    })
  })
}

export function restorePass (email) {
  return firebase.auth().sendPasswordResetEmail(email)
}

export function logout () {
  return firebase.auth().signOut()
}
